import ImageBarcodeReader from "./components/ImageBarcodeReader";
import StreamBarcodeReader from "./components/StreamBarcodeReader";

export { ImageBarcodeReader, StreamBarcodeReader };



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-barcode-reader/src/index.js
// module id = 70
// module chunks = 0